module.exports = __webpack_public_path__ + "img/planta_02.5883bb77.png";